import { Navigate, Routes, Route } from "react-router-dom";

import SaveTheDate from "./pages/save-the-date/save-the-date";
import Home from "./pages/home/home";
import Details from "./pages/details/details";
import OurStory from "./pages/our-story/our-story";
import OurPeople from "./pages/our-people/our-people";
import Gallery from "./pages/gallery/gallery";
import Registry from "./pages/registry/registry";
import QandA from "./pages/q-and-a/q-and-a";
import RSVP from "./pages/rsvp/rsvp";
import EInvite from "./pages/e-invite/e-invite";
import FoodPreferences from "./pages/food-preferences/food-pref";
import FindYourTable from "./pages/find-your-table/find-your-table";

export default function AppRoutes() {
  const routeLabels = [
    "HOME",
    "DETAILS",
    "OUR STORY",
    "OUR PEOPLE",
    "",
    "GALLERY",
    "REGISTRY",
    "Q & A",
    "RSVP",
  ];
  const routes = [
    { element: Home, path: "/" },
    { element: Details, path: "/details" },
    { element: OurStory, path: "/our-story" },
    { element: OurPeople, path: "/our-people" },
    { element: Gallery, path: "/gallery" },
    { element: Registry, path: "/registry" },
    { element: QandA, path: "/q-and-a" },
    { element: RSVP, path: "/rsvp" },
    { element: SaveTheDate, path: "/save-the-date", public: true },
    { element: EInvite, path: "e-invite", public: true },
    { element: FoodPreferences, path: "meal-preferences", public: true },
    { element: FindYourTable, path: "find-your-table", public: true },
  ];

  // const isAuthorized = sessionStorage.getItem("authorized") === "true";

  return (
    <Routes>
      {routes.map(({ path, element: Element, public: isPublic }, index) => {
        // // Allow save-the-date without auth
        // if (isPublic) {
        //   return <Route key={index} path={path} element={<Element />} />;
        // }

        // // Block protected routes if not authorized
        // if (!isAuthorized) {
        //   return (
        //     <Route
        //       key={index}
        //       path={path}
        //       element={<Navigate to="/" replace />}
        //     />
        //   );
        // }

        return <Route key={index} path={path} element={<Element />} />;
      })}

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
